@if (showCompactKitReadyBanner) {
  <div class="tw-relative tw-flex tw-items-center tw-gap-6 tw-rounded-2xl tw-border-[0.4px] tw-border-gray-300 tw-bg-white tw-py-4 tw-px-4 tw-pr-5 tw-shadow-z4 tw-font-body" (click)="buyRegimen(regimen.class)">
    <div class="tw-h-24 tw-w-27 tw-shrink-0 tw-overflow-hidden tw-rounded-2xl tw-bg-gray-100">
      <img class="tw-h-full tw-w-full tw-object-cover" [src]="regimen?.regimenCoverImage || coverImage" alt="regimen-cover" />
    </div>
    <div class="tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-2">
      @if (class === appConfig.Shared.Regimen.Class.HAIR) {
        @if (concernDisplayName) {
          <p class="tw-font-lexend tw-text-500 tw-leading-[21px] tw-font-medium tw-text-gray-800" i18n="@@hairKitForConcern">Hair Treatment Kit <span class="tw-font-[700] tw-lowercase">for {{ concernDisplayName }}</span></p>
        } @else {
        <p class="tw-font-lexend tw-text-500 tw-font-medium tw-text-gray-800" i18n="@@yourHairKitIsReady">Your hair treatment kit is ready</p>
        }
      } @else {
        @if (concernDisplayName) {
          <p class="tw-font-lexend tw-text-500 tw-font-medium tw-text-gray-800" i18n="@@skinKitForConcern">Skin Treatment Kit <span class="tw-font-[700] tw-lowercase">for {{ concernDisplayName }}</span></p>
        } @else {
          <p class="tw-font-lexend tw-text-500 tw-font-medium tw-text-gray-800" i18n="@@yourSkinKitIsReady">Your skin treatment kit is ready</p>
        }
      }
      <button csButton
              type="button"
              class="tw-w-fit tw-capitalize tw-max-w-full tw-text-400 tw-h-fit tw-py-[10px] tw-px-6 tw-m-0"
              style="border-radius: 8px !important;">
        <span i18n="@@buyNow">Buy Now</span>
      </button>
    </div>
  </div>
} @else {
<div id="new-regimen-banner" class="font-noto tw-flex tw-justify-center tw-flex-col tw-rounded-[15px] tw-overflow-hidden" (click)="buyRegimen(regimen.class)">
  <div [ngClass]="regimenImageBackgroundColor">
    <img id="cover-image" class="tw-w-full tw-rounded-[15px] max-h-[82px] tw-object-cover" alt="Products" [src]="coverImage" />
  </div>
  <div class="tw-flex tw-items-center tw-text-center tw-flex-col -tw-mt-14 tw-pt-12 tw-pb-5 tw-bg-white tw-relative tw-rounded-b-[15px]">
    <img id="doctor-image" class="tw-rounded-full tw-w-[93px] tw-object-cover tw-h-[93px] tw-absolute -tw-top-12 tw-left-1/2 -tw-translate-x-1/2" [src]="doctorImage || 'https://cdn.cureskin.com/app/img/regimen_banner_doctor.png'" alt="Doctor" style="border: 3px solid white" />
    <!-- HAIR with concern -->
    <p id="hair-message-with-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-10" *ngIf="class === appConfig.Shared.Regimen.Class.HAIR && concernDisplayName">
      <span class="tw-capitalize tw-font-bold">{{userName}},&nbsp;</span>
      <span i18n="@@hairRoutineForConcernReadyV2">
        <span class="tw-font-bold">your hair routine </span>for {{ concernDisplayName }} is ready
      </span>
    </p>
    <!-- HAIR without concern -->
    <p id="hair-message-without-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-8 tw-font-bold" *ngIf="class === appConfig.Shared.Regimen.Class.HAIR && !concernDisplayName">
      <span class="tw-capitalize">{{userName}},&nbsp;</span><span i18n="@@hairRoutineReadyNoConcernV2" class="tw-lowercase">your hair routine is ready</span>
    </p>
    <!-- FACE with concern -->
    <p id="face-message-with-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-10" *ngIf="class === appConfig.Shared.Regimen.Class.FACE && concernDisplayName">
      <span class="tw-capitalize tw-font-bold">{{userName}},&nbsp;</span>
      <span i18n="@@skinRoutineForConcernReadyV2">
        <span class="tw-font-bold">your skin routine </span>for {{ concernDisplayName }} is ready
      </span>
    </p>
    <!-- FACE without concern -->
    <p id="face-message-without-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-8 tw-font-bold" *ngIf="class === appConfig.Shared.Regimen.Class.FACE && !concernDisplayName">
      <span class="tw-capitalize">{{userName}},&nbsp;</span><span i18n="@@skinRoutineReadyNoConcernV2" class="tw-lowercase">your skin routine is ready</span>
    </p>
    <div class="tw-w-fit tw-flex tw-items-center tw-gap-3">
      @if(showDoubleCta) {
        <span class="tw-text-teal-600 tw-bg-white tw-border tw-border-teal-600 tw-py-[7px] tw-px-[22px] tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden" i18n="@@howToUse" (click)="seeInstructions()"> How to use </span>
      }
      <span i18n="@@seeDetails" class="tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">See Details</span>
    </div>
  </div>
</div>
}
